/** Angular */
import { Injectable } from '@angular/core';
/** Rxjs */
import { Observable } from 'rxjs';
/** Models */
/** Services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
import { DocTemplate } from '../models/doc-template.model';
import { BydModel } from '@sixense/byd-core-service';
import { DocTemplateInterface } from '../interfaces/doc-template.interface';

@Injectable({
  providedIn: 'root',
})
export class DocsTemplatesService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Get docs templates.
   *
   * @param projectId The Project ID
   * @returns Observable<DocTemplateResponse>
   */
  public getAllDocTemplates(projectId: number): Observable<BydModel<DocTemplate>> {
    this.path = `/v1/bimdata/projects/${projectId}/custom/report`;
    return this.getModels<DocTemplate>();
  }

  /**
   * Create Doc Template Response instance.
   *
   * @param jsonObject Template reponse.
   * @returns DocTemplateResponse.
   */
  public createNewInstance(jsonObject: DocTemplateInterface): DocTemplate {
    return new DocTemplate(jsonObject);
  }
}
